<style scoped lang="scss">
>>> .heading {
  line-height: 28px;
}
</style>

<template>
<div>
  <v-row>
    <v-col>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col sm="3">
              <admin-groups-originators v-model="originator" />
            </v-col>
            <v-col>
              <admin-groups-team :originator="originator" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col sm="3">
              <admin-groups-senior-funders v-model="seniorFunder" />
            </v-col>
            <v-col>
              <admin-groups-team-senior-funders :seniorFunder="seniorFunder"  />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  </div>
</template>

<script>
import AdminGroupsOriginators from '@/components/admin/groups/Originators';
import AdminGroupsTeam from '@/components/admin/groups/team/Team';
import AdminGroupsSeniorFunders from '@/components/admin/groups/SeniorFunders';
import AdminGroupsTeamSeniorFunders from '@/components/admin/groups/team/TeamSeniorFunders';

export default {
  name: 'AdminGroupsView',
  components: {
    AdminGroupsOriginators,
    AdminGroupsTeam,
    AdminGroupsSeniorFunders,
    AdminGroupsTeamSeniorFunders,
  },
  data: () => ({
    originator: null,
    seniorFunder: null,
  }),
};
</script>
